import React, { useMemo } from 'react';
import { Attachments, Attachment } from '@fiverr-private/attachments';
import { useUploadContext } from '../UploadContext';

export const AttachmentsUploadPreview = () => {
    const { rawAttachments, removeAttachment } = useUploadContext();
    const displayedAttachments = useMemo(
        () => rawAttachments.filter((attachment) => attachment.uploaded || attachment.errorMessage),
        [rawAttachments]
    );

    return (
        <Attachments>
            {displayedAttachments?.map((attachment) => (
                <Attachment
                    key={attachment.id || attachment.attachmentId}
                    fileSize={attachment.size}
                    name={attachment.file_name || attachment.name || ''}
                    hasError={attachment?.errorMessage ? true : undefined}
                    error={attachment?.errorMessage}
                    onRemove={() => removeAttachment?.(attachment.attachmentId)}
                />
            ))}
        </Attachments>
    );
};
